import { useTranslation } from "react-i18next";
import "../../../i18n";
import SectionLabel from "../components/SectionLabel";
import { Link } from "react-router-dom";

const FEATURES = [
  { icon: "🤖", bg: "#FFF7ED", key: "f1" },
  { icon: "📤", bg: "#EFF6FF", key: "f2" },
  { icon: "🗝️", bg: "#F0FDF4", key: "f3" },
  { icon: "📚", bg: "#FFF7ED", key: "f4" },
  { icon: "🌐", bg: "#FAF5FF", key: "f5" },
  { icon: "✍️", bg: "#ECFDF5", key: "f6" },
  { icon: "💬", bg: "#FFF7ED", key: "f7" },
  { icon: "⏱️", bg: "#EFF6FF", key: "f8" },
  { icon: "📊", bg: "#F0FDF4", key: "f9" },
];

function TeacherFeaturesSection() {
  const { t } = useTranslation("marketing");

  return (
    <section className="ul-tf-section ul-section" id="features">
      <div className="ul-tf-inner">
        <div className="ul-tf-header">
          <SectionLabel>{t("teacherFeatures.label")}</SectionLabel>
          <h2 className="ul-section-title">
            {t("teacherFeatures.titleLine1")}<br />
            <span style={{ color: "var(--ul-orange)" }}>{t("teacherFeatures.titleHighlight")}</span>
          </h2>
          <p className="ul-section-sub" style={{ maxWidth: 560, marginTop: 14 }}>
            {t("teacherFeatures.sub")}
          </p>
        </div>

        <div className="ul-tf-list">
          {FEATURES.map((f) => (
            <div key={f.key} className="ul-tf-item">
              <div className="ul-tf-item-icon" style={{ background: f.bg }}>{f.icon}</div>
              <div className="ul-tf-item-text">
                <p className="ul-tf-item-title">{t(`teacherFeatures.items.${f.key}.title`)}</p>
                <p className="ul-tf-item-desc">{t(`teacherFeatures.items.${f.key}.desc`)}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="ul-tf-cta-row">
          <Link to="/teacher-login" className="ul-btn-primary">{t("teacherFeatures.ctaFree")}</Link>
          <Link to="/request-demo" className="ul-btn-ghost">{t("teacherFeatures.ctaDemo")}</Link>
        </div>
      </div>
    </section>
  );
}

export default TeacherFeaturesSection;
